import type { ApiKeysList } from "@crux/contracts";
import { useQuery } from "@tanstack/react-query";
import { fetchApiKeys } from "../api/index.js";
import { queryKeys } from "../query-keys.js";

/** Every 3s while a new key waits for its app's first call (DESIGN.md "AI apps"). */
const WATCH_EVERY_MS = 3_000;

/**
 * The workspace's API keys and connections, the brands one can be limited to,
 * and the MCP address. With `until`, it asks again every few seconds until the
 * list satisfies it: the connect drawer's "Waiting for Claude Code to
 * connect", or a new sign-in appearing.
 */
export function useApiKeys(
  workspaceId: string,
  enabled: boolean,
  until?: (list: ApiKeysList) => boolean,
) {
  return useQuery({
    queryKey: queryKeys.apiKeys(workspaceId),
    queryFn: () => fetchApiKeys(workspaceId),
    enabled,
    refetchInterval: (query) => {
      if (until === undefined) return false;
      const list = query.state.data;
      return list !== undefined && until(list) ? false : WATCH_EVERY_MS;
    },
  });
}
